module.exports = __webpack_public_path__ + "img/Decoration_salle_mariage.903fa2d.jpg";